import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Florida = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Florida Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure form covering various home conditions required.
        </Text>

        <Text style={styles.listItem}>
          2. FIRPTA Disclosure: Foreign Investment in Real Property Tax Act
          disclosure may be required.
        </Text>

        <Text style={styles.listItem}>
          3. HOA Disclosure: Mandatory if the property is within a homeowner's
          association.
        </Text>

        <Text style={styles.listItem}>
          4. Buyer may, at Buyer's expense, have the Real Property surveyed and
          certified by a registered Florida surveyor ("Survey"). If Seller has a
          survey covering the Real Property, a copy shall be furnished to Buyer
          and Closing Agent within 5 days after Effective Date.
        </Text>

        <Text style={styles.listItem}>
          5. Radon Gas: Radon is a naturally occurring radioactive gas that,
          when it is accumulated in a building in sufficient quantities, may
          present health risks to persons who are exposed to it over time.
          Levels of radon that exceed federal and state guidelines have been
          found in buildings in Florida. Additional information regarding radon
          and radon testing may be obtained from your county health department.
        </Text>

        <Text style={styles.listItem}>
          6. Permits Disclosure: Except as may have been disclosed by Seller to
          Buyer in a written disclosure, Seller does not know of any
          improvements made to the Property which were made without required
          permits or made pursuant to permits which have not been properly
          closed. If Seller identifies permits which have not been properly
          closed or improvements which were not permitted, then Seller shall
          promptly deliver to Buyer all plans, written documentation or other
          information in Seller's possession, knowledge, or control relating to
          improvements to the Property which are the subject of such open
          permits or unpermitted improvements.
        </Text>

        <Text style={styles.listItem}>
          7. Mold: Mold is naturally occurring and may cause health risks or
          damage to property. If Buyer is concerned or desires additional
          information regarding mold, Buyer should contact an appropriate
          professional.
        </Text>

        <Text style={styles.listItem}>
          8. Flood Zone; Elevation Certification: Buyer is advised to verify by
          elevation certificate which flood zone the Property is in, whether
          flood insurance is required by Buyer's lender, and what restrictions
          apply to improving the Property and rebuilding in the event of
          casualty. If Property is in a "Special Flood Hazard Area" or "Coastal
          Barrier Resources Act" designated area or otherwise protected area
          identified by the U.S. Fish and Wildlife Service under the Coastal
          Barrier Resources Act and the lowest floor elevation for the
          building(s) and/or flood insurance rating purposes is below minimum
          flood elevation or is ineligible for flood insurance coverage through
          the National Flood Insurance Program or private flood insurance as
          defined in 42 U.S.C. §4012a, Buyer may terminate this Contract by
          delivering written notice to Seller within 20 days after Effective
          Date, and Buyer shall be refunded the Deposit thereby releasing Buyer
          and Seller from all further obligations under this Contract, failing
          which Buyer accepts existing elevation of buildings and flood zone
          designation of Property. The National Flood Insurance Program may
          assess additional fees or adjust premiums for pre-Flood Insurance Rate
          Map (pre-FIRM) non-primary structures (residential structures in which
          the insured or spouse does not reside for at least 50% of the year)
          and an elevation certificate may be required for actuarial rating.
        </Text>

        <Text style={styles.listItem}>
          9. Energy Brochure: Buyer acknowledges receipt of Florida
          Energy-Efficiency Rating Information Brochure required by Section
          553.996, F.S.
        </Text>

        <Text style={styles.listItem}>
          10. Lead-Based Paint: If Property includes pre-1978 residential
          housing, a lead-based paint disclosure is mandatory.
        </Text>

        <Text style={styles.listItem}>
          11. Property Tax Disclosure Summary: Buyer should not rely on the
          seller's current property taxes as the amount of property taxes that
          the buyer may be obligated to pay in the year subsequent to purchase.
          A change of ownership or property improvements triggers reassessments
          of the property that could result in higher property taxes. If you
          have any questions concerning valuation, contact the county property
          appraiser's office for information.
        </Text>

        <Text style={styles.listItem}>
          12. Seller shall furnish a copy of a prior owner's policy of title
          insurance or other evidence of title and pay fees for: (A) a
          continuation or update of such title evidence, which is acceptable to
          Buyer's title insurance underwriter for reissue of coverage; (B) tax
          search; and (C) municipal lien search. Buyer shall obtain and pay for
          post-Closing continuation and premium for Buyer's owner's policy, and
          if applicable, Buyer's lender's policy. Seller shall not be obligated
          to pay more than $200 for abstract continuation or title search
          ordered or performed by Closing Agent.
        </Text>

        <Text style={styles.listItem}>
          13. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          14. <Text style={styles.underline}>Coastline Disclosure Form</Text> –
          If a property is located on the coast or oceanfront, it must be
          disclosed that the area is subject to erosion and federal and state
          regulations.
        </Text>

        <Text style={styles.listItem}>
          15. <Text style={styles.underline}>Condominium Disclosure Form</Text>{' '}
          – If a property is located in a condominium community, this disclosure
          must be given to the buyer along with the charter or articles of the
          condominium.
        </Text>

        <Text style={styles.listItem}>
          16.{' '}
          <Text style={styles.underline}>
            Homeowner's Assoc. Disclosure Form
          </Text>{' '}
          – Required for property located in a homeowner's association.
        </Text>

        <Text style={styles.listItem}>
          17. <Text style={styles.underline}>Radon Gas Disclosure</Text> –
          Notification must be provided on at least one document, form, or
          application executed at the time of or before the contract for the
          sale and purchase of any building.
        </Text>

        <Text style={styles.listItem}>
          18. <Text style={styles.underline}>Required Disclosure of Facts</Text>{' '}
          – Sellers must disclose facts materially affecting the value or
          desirability of the property that are not readily observable and are
          unknown to the buyer.
        </Text>

        <Text style={styles.listItem}>
          19.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – Though a specific form is not required by law, sellers must disclose
          any material defects to a potential buyer.
        </Text>
      </View>
    </View>
  );
};

export default Florida;
